import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BuildingOfficeIcon, 
  PhoneIcon, 
  EnvelopeIcon
} from '@heroicons/react/24/outline';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-800 text-white section-padding">
      <div className="container-custom">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-slate-600 to-slate-800 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">3A</span>
              </div>
              <div>
                <span className="text-2xl font-display font-bold">3 Arrows Media</span>
                <div className="text-sm text-slate-400">Digital Marketing Excellence</div>
              </div>
            </div>
            <p className="text-slate-400 mb-6">
              Your strategic partner for digital transformation and sustainable business growth 
              through innovative marketing solutions.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-slate-700 hover:bg-slate-600 rounded-full flex items-center justify-center transition-colors" title="LinkedIn">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-700 hover:bg-slate-600 rounded-full flex items-center justify-center transition-colors" title="Twitter">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2s9 5 20 5a9.5 9.5 0 00-9-5.5c4.75 2.45 7-7 7-7"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-700 hover:bg-slate-600 rounded-full flex items-center justify-center transition-colors" title="Facebook">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-700 hover:bg-slate-600 rounded-full flex items-center justify-center transition-colors" title="Instagram">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-display font-bold mb-6">Services</h4>
            <ul className="space-y-3 text-slate-400">
              <li><Link to="/lead-generation" className="hover:text-white transition-colors">Lead Generation</Link></li>
              <li><Link to="/mobile-development" className="hover:text-white transition-colors">Mobile Development</Link></li>
              <li><Link to="/website-development" className="hover:text-white transition-colors">Website Development</Link></li>
              <li><Link to="/digital-marketing" className="hover:text-white transition-colors">Digital Marketing</Link></li>
              <li><Link to="/social-media" className="hover:text-white transition-colors">Social Media Management</Link></li>
              <li><Link to="/meta-ads" className="hover:text-white transition-colors">Meta Ads Management</Link></li>
              <li><Link to="/google-ads" className="hover:text-white transition-colors">Google Ads Management</Link></li>
              <li><Link to="/amazon-ads" className="hover:text-white transition-colors">Amazon Ads Management</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-display font-bold mb-6">Company</h4>
            <ul className="space-y-3 text-slate-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/industries" className="hover:text-white transition-colors">Industries</Link></li>
              <li><Link to="/case-studies" className="hover:text-white transition-colors">Case Studies</Link></li>
              <li><Link to="/portfolio" className="hover:text-white transition-colors">Portfolio</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-display font-bold mb-6">Contact Information</h4>
            <div className="space-y-4 text-slate-400">
              <div className="flex items-center space-x-3">
                <BuildingOfficeIcon className="w-5 h-5" />
                <div>
                  <div>Corporate Headquarters</div>
                  <div className="text-sm">123 Business Plaza, Suite 500</div>
                  <div className="text-sm">Metropolitan City, State 12345</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <PhoneIcon className="w-5 h-5" />
                <div>
                  <div>+91-97118 34001</div>
                  <div className="text-sm">Monday - Friday, 8AM - 6PM EST</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="w-5 h-5" />
                <div>
                  <div>hello@3arrowsmedia.com</div>
                  <div className="text-sm">Response within 24 hours</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-700 pt-8 text-center text-slate-400">
          <p>&copy; 2024 3 Arrows Media. All rights reserved.</p>
          <div className="mt-2 space-x-6">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/data-protection" className="hover:text-white transition-colors">Data Protection</Link>
            <Link to="/accessibility" className="hover:text-white transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;